/**
 * Sending the browser to sign in, without losing where it was.
 *
 * Every 401 used to do `window.location.href = '/api/auth/login'`, and the
 * gateway's callback always lands on `/`. Someone whose session lapsed while a
 * background poll ran on `/work?tab=progress` came back on the home page, and a
 * 401 on a *button* (Claim, Submit, a verdict) only produced a red toast that
 * every retry repeated. The gateway now honours a same-origin `?next=` path
 * (api-gateway `routers/auth.py: safe_return_path`), so the redirect carries it.
 */

let redirecting = false

/** The current location as a same-origin path, or null if it is not worth keeping. */
export function currentReturnPath(loc: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location): string | null {
  const path = `${loc.pathname}${loc.search}${loc.hash}`
  if (!path.startsWith('/') || path.startsWith('//')) return null
  // The home page is where the callback lands anyway; the viewer has its own
  // session dialog and is opened from a task card, not navigated back to.
  if (path === '/' || path.startsWith('/ohif/')) return null
  return path.length <= 512 ? path : null
}

export function loginUrl(next: string | null = currentReturnPath()): string {
  return next ? `/api/auth/login?next=${encodeURIComponent(next)}` : '/api/auth/login'
}

/** Navigate to sign-in once, however many requests 401 at the same moment. */
export function redirectToLogin(): void {
  if (redirecting) return
  redirecting = true
  window.location.href = loginUrl()
}

/** Test seam: the module-level latch would otherwise leak between tests. */
export function _resetRedirectLatch(): void {
  redirecting = false
}
